import { render } from "./CensusReport.vue?vue&type=template&id=cb11dc50&ts=true"
import script from "./CensusReport.vue?vue&type=script&lang=ts"
export * from "./CensusReport.vue?vue&type=script&lang=ts"

import "./CensusReport.vue?vue&type=style&index=0&id=cb11dc50&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__